<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>

<ng-template #content>
  <div class="modal-header modalTitle1">
    <div class="modal-title">Add Digital Asset ID</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="masterNameSelected" (change)="onMasterChange($event.target.selectedIndex)">
        <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
      </select>
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="description"
             placeholder="Asset ID">
    </div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="close()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
